<template>
  <v-expansion-panel
    v-bind="$attrs"
    v-on="$listeners"
    class="a-expansion-panel"
  >
    <!-- Pass on all named slots -->
    <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />

    <!-- Pass on all scoped slots -->
    <template
      v-for="slot in Object.keys($scopedSlots)"
      :slot="slot"
      slot-scope="scope"
      ><slot :name="slot" v-bind="scope"
    /></template>
  </v-expansion-panel>
</template>

<script>
export default {
  name: "AExpansionPanel",
};
</script>

<style scoped>
.a-expansion-panel /deep/ .v-expansion-panel-header {
  color: white !important;
  background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.08) 100%
    ),
    #006cad !important;
  border-radius: 8px 8px 0px 0px !important;
  font-weight: 700 !important;
  height: 48px !important;
}

.a-expansion-panel-pale-blue /deep/ .v-expansion-panel-header{
  /* background-color: var(--v-appBarT-base) !important; */
  color: var(--v-appMenu-base) !important;
  background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.08) 100%
    ),
    var(--v-appBarT-base) !important;
}

::v-deep.a-expansion-panel:not(.a-expansion-panel-pale-blue)
  .v-expansion-panel-header
  .v-expansion-panel-header__icon
  .v-icon {
  color: white !important;
}

::v-deep.a-expansion-panel:is(.a-expansion-panel-pale-blue)
  .v-expansion-panel-header
  .v-expansion-panel-header__icon
  .v-icon, ::v-deep.a-expansion-panel:is(.a-expansion-panel-pale-blue) .v-expansion-panel-header .v-icon{
  color: var(--v-appMenu-base) !important;
}

.a-expansion-panel /deep/ .v-expansion-panel-content__wrap {
  padding: 20px !important;
  font-family: "Noto Sans JP" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
}
.a-expansion-panel /deep/ .v-expansion-panel-header--active {
    height: 48px !important;
    min-height: 48px !important
}
</style>